import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-view-maintenance-request-dialog',
  templateUrl: './view-maintenance-request-dialog.component.html',
  styleUrls: [
    './view-maintenance-request-dialog.component.scss'
  ]
})
export class ViewMaintenanceRequestDialogComponent implements OnInit {
  request: any;

  userImages: string[] = [];
  employeeImages: string[] = [];

  constructor(public bsModalRef: BsModalRef) {

  }

  public ngOnInit(): void {
    this.addUserImages();
    this.addEmployeeImages();
  }

  get employeeComment(): string {
    return this.request.em_comment || '-';
  }

  private addEmployeeImages(): void {
    this.employeeImages = [];
    this.addImage(this.employeeImages, 'em_photo1');
    this.addImage(this.employeeImages, 'em_photo2');
    this.addImage(this.employeeImages, 'em_photo3');
  }

  private addUserImages(): void {
    this.userImages = [];
    this.addImage(this.userImages, 'image_1');
    this.addImage(this.userImages, 'image_2');
    this.addImage(this.userImages, 'image_3');
  }

  private addImage(array: string[], property: string): void {
    if (!isNullOrUndefined(this.request[property])) {
      array.push('https://amalooloo.group/images' + this.request[property]);
    }
  }
}
